<template>
  <v-layout row align-center justify-space-around>
    <v-flex xs12 order-lg2 id="TweetsByRetweets">
      <v-list two-line class="scroll-y" style="max-height: 400px"  v-if="dataState === 'loading' || dataState === 'ready'" :class="dataState !== 'ready' ? 'blurClass' : ''">
        <template v-for="(item, index) in tweets">
          <v-list-tile
            :key="item._twitter_id"
            avatar
            class='pa-0 my-1'
            @click="goToTweet(item._twitter_id, item._user_screen_name)">
            <v-list-tile-avatar class="pointer">
              <img :id="index" :src="item._user_profile_image_url_https" @error="alternateImg(index)">
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title v-html="item._user_name" class="pointer"></v-list-tile-title>
              <v-list-tile-title v-html="'@'+item._user_screen_name" class="pointer caption"></v-list-tile-title>
              <v-list-tile-sub-title v-html="item._text" class="pointer"></v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-avatar @click.stop="backtrack(item._tweet_id, 'tweet', item._created_at)" color="secondary" size="40" class="pointer">
              <v-btn icon>
                <v-icon>fas fa-backward</v-icon>
              </v-btn>
            </v-list-tile-avatar>
            <v-list-tile-avatar @click.stop="selectedTweet = item._tweet_id; deleteTweetConfirmationDialog = true" color="secondary" size="40" class="pointer">
              <v-btn icon>
                <v-icon>fas fa-trash</v-icon>
              </v-btn>
            </v-list-tile-avatar>
            <v-list-tile-avatar color="secondary" size="40" class="pointer">
              <span class="pointer accent--text caption">{{ numberOfRetweets(item._retweet_count) }}</span>
            </v-list-tile-avatar>
          </v-list-tile>
          <v-divider v-if="tweets[index+1]"></v-divider>
        </template>
      </v-list>
      <template v-if="dataState === 'loading'">
        <center class="alternateState">
          <v-progress-circular
            :size="70"
            :width="7"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </center>
      </template>
      <template v-else-if="dataState === 'noData'">
        <div class="d-flex" style="flex-direction: column; align-items: center"><v-icon class="primary--text" style="font-size: 40px !important;width:100%">warning</v-icon><p class="accent--text mb-0 ml-2 subheading font-weight-bold">no data found</p></div>
      </template>
      <template v-else-if="dataState === 'error'">
        <div class="d-flex" style="flex-direction: column; align-items: center"><v-icon class="error--text" style="font-size: 40px !important">warning</v-icon><p class="accent--text mb-0 ml-2 subheading font-weight-bold">error connecting to server</p></div>
      </template>
    </v-flex>
    <v-dialog
      v-model="deleteTweetConfirmationDialog"
      width="300"
    >
      <v-card class="secondary">
        <v-card-title class="headline">Delete tweet?</v-card-title>
        <v-card-text>
          <v-btn @click="deleteTweet" :loading="deleteLoading">Confirm</v-btn>
          <v-btn @click="deleteTweetConfirmationDialog = false; selectedTweet = null" :disabled="deleteLoading">Cancel</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<style>
  #TweetsByRetweets .v-list__tile{
    height: 80px !important
  }
</style>
<style scoped>
  .pointer{ cursor: pointer; }
  .alternateState{
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .blurClass{
    filter: blur(5px);
    -webkit-filter: blur(5px);
  }
</style>
<script>
import axios from 'axios'
import underscore from 'underscore'
import { mapGetters, mapMutations } from 'vuex'
import numeral from 'numeral'

export default {
  props: {
    filters: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      dataState: 'loading',
      tweets: [],
      deleteTweetConfirmationDialog: false,
      selectedTweet: null,
      deleteLoading: false
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
    ...mapGetters('filters', ['getQuery', 'getFilters'])
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    deleteTweet () {
      this.deleteLoading = true
      axios.all([
        this.$store.dispatch('deleteTweetById', {id: this.selectedTweet, query: '?projectUuid=' + this.getFilters.projectUuid})
      ]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          this.selectedTweet = null
          this.deleteTweetConfirmationDialog = false
        } else {
          this.notify({message: 'Something went wrong while fetching data.', show: true})
        }
        this.getData()
        this.deleteLoading = false
      })).catch((err) => {
        this.deleteLoading = false
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    },
    backtrack: function (id, type, date) {
      let query = this.$route.query
      query.id = id
      query.type = type
      query.date = date
      query.connections = ['reply', 'retweet', 'quote']
      query.objects = ['tweet']
      this.$router.push({ path: '/backtracker', query: query })
    },
    numberOfRetweets: function (value) {
      return Number(value) > 999 ? numeral(Number(value)).format('0.0a').toUpperCase() : value
    },
    alternateImg: function (index) {
      this.tweets[index]._user_profile_image_url_https = 'https://abs.twimg.com/sticky/default_profile_images/default_profile.png'
    },
    goToTweet (id, name) {
      window.open('https://twitter.com/' + name + '/status/' + id, '_blank')
    },
    getData: function () {
      this.dataState = 'loading'
      axios.all([
        this.$store.dispatch('getTweets', this.getQuery({sortBy: '_retweet_count', order: 'desc', pageSize: 30}))
      ]).then(axios.spread((r1) => {
        if (r1.data.status === 'SUCCESS') {
          this.tweets = r1.data.payload
          if (r1.data.payload.length > 0) {
            this.dataState = 'ready'
          } else {
            this.dataState = 'noData'
          }
        } else {
          this.dataState = 'error'
          this.notify({message: 'Something went wrong while fetching data.', show: true})
        }
      })).catch((err) => {
        this.dataState = 'error'
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    }
  },
  watch: {
    filters: {
      deep: true,
      immediate: true,
      handler (newVal, oldVal) {
        if (!underscore.isEqual(newVal, oldVal) && this.filters.dirty === false) {
          this.getData()
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/rankings/TweetsByRetweets.vue